import {
  ADDBOOK,
  DELETEBOOK,
  EDITBOOK,
  LOADED,
  SET_UPDATE_BOOK_ID,
} from "./actionTypes";

export const addBook = (book) => ({
  type: ADDBOOK,
  payload: book,
});

export const editBook = (id, book) => ({
  type: EDITBOOK,
  payload: {
    id,
    book,
  },
});

export const deleteBook = (id) => ({
  type: DELETEBOOK,
  payload: id,
});

export const setUpdateBookId = (id, value) => ({
  type: SET_UPDATE_BOOK_ID,
  payload: {
    id,
    value,
  },
});

export const loaded = (books) => ({
  type: LOADED,
  payload: books,
});
